import { render, staticRenderFns } from "./SupportContextSummary.vue?vue&type=template&id=4f2ef3b4&scoped=true"
import script from "./SupportContextSummary.vue?vue&type=script&lang=js"
export * from "./SupportContextSummary.vue?vue&type=script&lang=js"
import style0 from "./SupportContextSummary.vue?vue&type=style&index=0&id=4f2ef3b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ef3b4",
  null
  
)

export default component.exports